import { render, staticRenderFns } from "./WToggle.vue?vue&type=template&id=6d5f2fa4&scoped=true&lang=pug&"
import script from "./WToggle.vue?vue&type=script&lang=js&"
export * from "./WToggle.vue?vue&type=script&lang=js&"
import style0 from "./WToggle.vue?vue&type=style&index=0&id=6d5f2fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5f2fa4",
  null
  
)

export default component.exports